// ChatConfidenceFactor — ONE weighted factor of an answer's confidence score
// (VaultOS v2 design §4.3). Rendered by ChatMessage's `Confidence.Breakdown`
// via `childExtends: 'ChatConfidenceFactor'`, six times, in the spec's order:
// precedent · coverage · authority · freshness · consistency · self.
//
// Row state (built by ChatMessage's `confRows` scope method):
//   { key, factor, labelKey, value, pct }
// `labelKey` is the polyglot key as a LITERAL, minted upstream. Building it
// here from `factor` would be a runtime-assembled key — invisible to grep, to
// the en/ka parity test and to extraction (docs/I18N-CONVENTION.md §1.3).
// `value === null` means the server sent no number for that factor — the row
// then prints an em dash and an empty bar. That is NOT the same as zero, and
// the two must never render alike: an omitted factor says "not measured", a
// zero says "measured, and it failed".
//
// The bar is two flat fills and nothing else — no gridline, no axis, no
// outline (design-direction §8/§11). The fill takes `currentColor`, which the
// Confidence container sets to the band's semantic ink, so the bars and the
// pill above them are one reading rather than two colour decisions.
//
// FA204 / frank trap — no module-scope const is read from any factory here;
// the label goes through `el.call('polyglot', …)`, a runtime string lookup
// that survives frank.toJSON.
export const ChatConfidenceFactor = {
  flow: 'x',
  align: 'center left',
  gap: 'Z',
  width: '100%',
  minWidth: '0',
  // One fontSize for the whole row: spacing tokens are em-based, so the
  // label, the bar and the figure only line up when they share it (Rule 34).
  fontSize: 'X',

  FactorName: {
    tag: 'span',
    text: (el, s) => el.call('polyglot', s.labelKey || ''),
    color: 'caption',
    flexShrink: '0',
    // A FLOOR, not a fixed width: a hard `width` at this font size clips the
    // longest label ("Self-reported") on a narrow drawer.
    minWidth: 'D',
    whiteSpace: 'nowrap'
  },

  Track: {
    flex: '1 1 0',
    minWidth: '0',
    height: 'Y',
    round: 'radiusPill',
    background: 'selected',
    overflow: 'hidden',
    Fill: {
      height: '100%',
      round: 'radiusPill',
      background: 'currentColor',
      width: (el, s) => s.pct + '%',
      transition: 'C defaultBezier width'
    }
  },

  FactorValue: {
    tag: 'span',
    text: (el, s) => (s.value == null ? '—' : s.pct + '%'),
    color: 'caption',
    flexShrink: '0',
    minWidth: 'B',
    textAlign: 'right'
  }
}
